export default {
  fileInputLabel: {
    id: 'profile_page_legal_documents_tab_file_input_label',
    defaultMessage: 'Select file',
  },
  documentTypeslabel: {
    id: 'profile_page_legal_documents_tab_document_types_label',
    defaultMessage: 'Choose type',
  },
  submitButton: {
    id: 'profile_page_legal_documents_tab_submit_button',
    defaultMessage: 'Add file',
  },
  fileInputErrorMaxSize: {
    id: 'profile_page_legal_documents_tab_file_error_max_size',
    defaultMessage: 'Uploaded file is too big',
  },
  fileInputErrorMimeType: {
    id: 'profile_page_legal_documents_tab_file_error_mimetype',
    defaultMessage: 'Only .png, .jpg, .jpeg or .pdf are allowed',
  },
  fileInputDescription: {
    id: 'profile_page_legal_documents_tab_file_input_description',
    defaultMessage: 'Accepted formats: PDF, JPG, JPEG or PNG',
  },
  requiredField: {
    id: 'profile_page_legal_documents_tab_form_required_field',
    defaultMessage: 'This field is required',
  },
  toastAddSuccessContent: {
    id: 'profile_page_add_document_toast_succcess_content',
    defaultMessage: 'Document added ✔️',
  },
}
